export async function fetchTopicOptions(municipality) {
  // Base topic options
  const topicOptions = [
    'Building - Application Inquiry',
    'Building - Sign Inquiry',
    'Building - Dock Inquiry',
    'Building - Pool/Hot Tub Inquiry',
    'Building - Shed Inquiry',
    'Building - General Inquiry',
    'Building - Inquiry',
    'Engineering - Grading and Drainage Inquiry',
    'Planning - Consent General Inquiry',
    'Planning - Heritage',
    'Planning - Minor Variance General Inquiry',
    'Planning - Pre-consultation',
    'Planning - Sign Permit',
    'Planning - Site Plan Inquiry',
    'Planning - Zoning Certificate',
    'Planning - Zoning Compliance Letter',
    'Planning - Zoning General Inquiry',
    'Other',
  ];

  const client = useSupabaseClient();
  const allModules = await useCachedData(municipality, 'modules');

  // Filter out disabled modules
  const enabledModules = allModules.filter(module => !module.disabled);

  // Fetch all non-disabled modules for the municipality and unshift them to the topicOptions array
  topicOptions.unshift(...enabledModules.map(module => module.name));
  return topicOptions;
}